import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';
import {
  areAllPermissionsEnabled,
  getSocietyPermissionEntry,
} from 'modules/society/utils/societyPermissions';

import { Guest, Society } from 'types';

type SocietyGuestsAccessBadgeProps = {
  guest: Guest;
  society: Society;
};

const SocietyGuestsAccessBadge: FC<SocietyGuestsAccessBadgeProps> = ({
  guest,
  society,
}) => {
  const { t } = useTranslate();

  const badge = {
    text: 'AllSections',
    color: 'danger',
  };

  const currentSocietyPermissions = getSocietyPermissionEntry(
    guest?.guestPermissions,
    society?.['_id']
  );

  const hasAllPermissionsEnabled = areAllPermissionsEnabled(
    currentSocietyPermissions
  );

  if (currentSocietyPermissions && !hasAllPermissionsEnabled) {
    badge.text = t('SomeSections');
    badge.color = 'warning';
  }

  return (
    <span className={`badge badge-dot badge-${badge.color}`}>
      {t(badge.text)}
    </span>
  );
};

export default SocietyGuestsAccessBadge;
